@if (filteredData?.pageTitle) {
  <div class="heading">
    <div class="container">
      @if (route !== 'escort-odense' && route !== 'escort-aarhus' && route !== 'escort-aalborg' && route !== 'escort-valby' && route !== 'escort-koebenhavn' && route !== 'massage-aalborg' && route !== 'massage-odense' && route !== 'massage-koebenhavn' && route !== 'massage-aarhus') {
        <p>{{ filteredData!.pageTitle }}</p>
      }
    </div>
  </div>
}
<!-- END! page-top-section -->

<!-- <app-search-area></app-search-area> -->
@if (filteredData) {
  <app-spot-search-area [pageData]="filteredData"></app-spot-search-area>
}
<!-- END! search-area -->
<div [innerHTML]="structuredData"></div>
<section class="product-main">
  <div class="container">
    <div class="product-list-main">
      <!-- END! filter-area -->
      @if (filteredData) {
        <app-spot-list [pageData]="filteredData"></app-spot-list>
      }
      <!-- END! product-list-right -->
    </div>
    <!-- END! product-list-main -->
  </div>
</section>
<!-- END! product-main -->
